import { render, staticRenderFns } from "./PercentageChart.vue?vue&type=template&id=74c4de8b&scoped=true"
import script from "./PercentageChart.vue?vue&type=script&lang=js"
export * from "./PercentageChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c4de8b",
  null
  
)

export default component.exports